module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "main-nav"
  }, [_c('nav', [_c('ul', [_c('li', {
    staticClass: "list-icon"
  }, [_c('router-link', {
    attrs: {
      "to": "/lists"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("list")]), _vm._v("Lists")])], 1), _vm._v(" "), _c('li', {
    staticClass: "meal-icon"
  }, [_c('router-link', {
    attrs: {
      "to": "/meal-plans"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("shopping_basket")]), _vm._v("Meal Plans")])], 1), _vm._v(" "), _c('li', {
    staticClass: "add-icon"
  }, [_c('i', {
    staticClass: "material-icons",
    on: {
      "click": _vm.modalChange
    }
  }, [_vm._v("add_circle_outline")])]), _vm._v(" "), _c('li', {
    staticClass: "recipe-icon"
  }, [_c('router-link', {
    attrs: {
      "to": "/recipes"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("collections_bookmark")]), _vm._v("Recipes")])], 1), _vm._v(" "), _c('li', {
    staticClass: "account-icon"
  }, [_c('router-link', {
    attrs: {
      "to": "/account"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("account_circle")]), _vm._v("Account")])], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.modalOpen) ? _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-top"
  }, [_c('i', {
    staticClass: "material-icons pull-right",
    on: {
      "click": _vm.modalChange
    }
  }, [_vm._v("close")])]), _vm._v(" "), _c('ul', _vm._l((_vm.randomRecipes), function(recipe) {
    return _c('li', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(recipe.title) + "\n\t\t\t\t\t\t\t")])
  })), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--raised",
    on: {
      "click": _vm.newRandomRecipes
    }
  }, [_vm._v("Random")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--raised",
    on: {
      "click": _vm.addMeals
    }
  }, [_vm._v("Add Meals")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "modal"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51098ebb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 136
// module chunks = 0